import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import '../styles/TermsOfService.css';

const TermsOfService = () => {
  const navigate = useNavigate();
  const termsOfService = `
Terms of Service
Last Updated: April 5, 2025

1. Introduction
Sync is a music streaming app where artists pay $4.99/month or $39.99/year and earn based on their percentage of platform streams.

2. User Accounts
To use Sync, you must create an account. You are responsible for keeping your account credentials confidential and for all activities under your account. Notify us immediately of any unauthorized use. Sync is not liable for losses or damages resulting from unauthorized access to your account.

3. Content Ownership and License
You retain ownership of all original content you create and upload to Sync ("User Content"). By uploading User Content, you grant Sync a non-exclusive, worldwide, royalty-free license to use, display, reproduce, and promote your content on our platform and in related marketing materials, solely to operate and promote Sync. You represent that you have the rights to grant this license.

4. SyncPro Subscription and Revenue Distribution
Sync offers an optional "SyncPro" subscription for enhanced features at $4.99 USD per month or $39.99 USD per year. Payments are processed via the App Store, which deducts a 15% commission (currently $0.75 per $5 subscription) as part of the App Store Small Business Program. The remaining amount (e.g., $4.25 per $5 subscription) is considered Sync’s "net revenue."

- Until Sync reaches 10,000 registered users, 100% of net revenue is pooled monthly and distributed to artists based on their percentage of total platform streams during that period.
- Once Sync exceeds 10,000 registered users, 80% of net revenue will be distributed to artists based on their stream percentage, with 20% retained by Sync to support platform operations and development.

Payments to artists are processed monthly via bank transfer, subject to a minimum payout threshold of $10. All amounts are net of applicable taxes, currency conversion fees, or other third-party charges. Sync reserves the right to adjust this model with notice via updates to these Terms.

5. Prohibited Conduct
You agree not to:
   - Upload, post, or share content that is illegal, offensive, defamatory, or infringes on others’ rights (e.g., copyright, privacy).
   - Use Sync to harass, spam, or harm others.
   - Attempt to reverse-engineer, hack, or disrupt Sync’s services.
Sync may remove violating content and suspend or terminate accounts at its discretion.

6. Termination
Sync may suspend or terminate your account at any time, with or without notice, for reasons including but not limited to violation of these Terms, fraudulent activity, or operational needs. Upon termination, your access to Sync ends, but these Terms’ provisions (e.g., content licenses) may survive.

7. Changes to Terms
We may update these Terms at any time. Changes will be posted here, and significant updates may be communicated via email or in-app notifications. Your continued use of Sync after changes constitutes acceptance of the revised Terms.

8. Disclaimer and Limitation of Liability
Sync is provided "as is" without warranties. We are not liable for indirect, incidental, or consequential damages arising from your use of the platform, to the extent permitted by law.
  `;

  return (
    <div className="terms-of-service-container">
      <div className="header-container">
        <button className="back-button" onClick={() => navigate(-1)}>
          <FaArrowLeft size={24} />
        </button>
        <h1 className="header">Terms of Service</h1>
        <div className="placeholder"></div>
      </div>
      <div className="content">
        <p className="text">{termsOfService}</p>
      </div>
    </div>
  );
};

export default TermsOfService;